import { atom } from "recoil"
import { ATOMS_KEYS } from "../atom-keys"

export const switchReservationsState = atom<string | undefined>({
	key: ATOMS_KEYS.SWITCHRESERVATIONSTATES,
	default: undefined,
})
